module.exports = __webpack_public_path__ + "img/2-2.eba64fe3.jpg";